// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

// Backends are not configured here: API_HOST_BY_FE_HOST in constants/domains.ts
// maps each frontend host to the backend it talks to, for every build. This
// flag only says which build is running.
export const environment = {
  production: false,
};
